<template src="./templates/index.html" />

<script type="text/ecmascript-6">
import {
  mapGetters,
  mapActions
} from 'vuex'
import FouGrid from 'components/layout/fou-grid/'

import {h} from 'vue'

export default {
  name: 'FouOverlay',

  props: {
    gridCols: {
      type: [String, Number],
    }
  },

  components: {
    'overlay-content': {
      name: 'OverlayContent',
      render() {
        return this.visibility ? h('div', [this.content]) : null
      },
      computed: {
        ...mapGetters('overlay', ['visibility', 'content'])
      }
    },
    ...FouGrid
  },

  computed: {
    ...mapGetters('overlay', ['visibility', 'cols']),
    ...mapGetters('submissions', ['liveSpinner','getCustomPackageModal']),
    ...mapGetters('profile', ['getFoundryModal']),
    ...mapGetters('binaries',  ['getLiveModalCancelButton']),
    offSpace() {
      return Math.floor((this.computedGridCols - this.cols) / 2)
    },
    computedGridCols() {
      return this.gridCols || this.$store.getters['settings/gridCols']
    }
  },
  methods: {
    ...mapActions('overlay', ['show', 'hide', 'freezeDocument']),
    emitClose () {
      this.$events.$emit('live_update:cancel')
      this.$events.$emit('deleteLiveFont')
      this.$events.$emit('closePopUp')
      this.$store.commit('submissions/setCustomPackageModal', false)
      this.hide()
    }
  },

  watch: {
    visibility: function () {
      this.freezeDocument()
    }
  },

  created () {
  },

  beforeUnmount () {
  }
}
</script>

<style lang="scss" src="./stylesheets/index.scss" module></style>
